import * as React from 'react';
import { Link } from 'gatsby';
import { childClassClosure, baseClassAnd, ClassableProps } from '@jcharlesworthuk/your-mum-core/dist/functions';
import { BlogArticlesContext } from '@Contexts';
import { useContext } from 'react';
import { changeSvgToPng } from '@jcharlesworthuk/your-mum-core/dist/functions';
import { Article } from '@jcharlesworthuk/your-mum-frontend/models';
import ArticleList from '@jcharlesworthuk/your-mum-frontend/components/lists/ArticleList';

const baseClass = 'office-dashboard-menu';
const childClass = childClassClosure(baseClass);


type Props = ClassableProps & {
};


const MdxArticleList: React.FunctionComponent<Props> = props => {
    const { latestArticles } = useContext(BlogArticlesContext);
    return <ArticleList className={childClass('list')} articles={latestArticles} linkComponent={Link} />
}

export default MdxArticleList;
